import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgMessageGlyphSecondary from './svgs/MessageGlyphSecondary.js';
import SvgMessageGlyph from './svgs/MessageGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var messageGlyph = (props => useIcon(SvgMessageGlyph, SvgMessageGlyphSecondary, props));

export { messageGlyph as default };
